export interface Month {
    year: number;
    month: number;
}

export const monthByNumber: { [key: number]: string } = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December'
};

const numMonths = 12;

export const getEstimationMonths = (currentYear: number, currentMonth: number): Month[] => {
    const thisYearMonths = getThisYearMonths(currentMonth).map(
        (_, index: number): Month => ({
            year: currentYear,
            month: currentMonth + index
        })
    );
    const nextYearMonths = getNextYearMonths(thisYearMonths.length).map(
        (_, index: number): Month => ({ year: currentYear + 1, month: getMonth(index + 1) })
    );
    return [...thisYearMonths, ...nextYearMonths];
};

export const getNextMonths = (currentYear: number, currentMonth: number): Month[] =>
    collectionFrom(3).map(
        (_, index): Month => ({
            month: getMonth(index + currentMonth),
            year: currentMonth + index <= numMonths ? currentYear : currentYear + 1
        })
    );

const getMonth = (index: number): number => (index > numMonths ? index % numMonths : index);

// tslint:disable:no-any
const collectionFrom = (numItems: number): any[] => Array.from(new Array(numItems));

const getThisYearMonths = (currentMonth: number): any[] => collectionFrom(numMonths).slice(currentMonth - 1);

const getNextYearMonths = (numMonthsFromCurrentYear: number): any[] =>
    numMonthsFromCurrentYear === numMonths ? [] : collectionFrom(numMonths).slice(0, numMonths - numMonthsFromCurrentYear);

export const areSame = (a: Month, b: Month): boolean => a.month === b.month && a.year === b.year;



// WEBPACK FOOTER //
// ./src/view/admin/getEstimationMonths.ts